import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelConstructorType } from '../../types';
import { type RecordLayout } from 'components/framework/models';

export class EpicName extends Field {
  static availableForModel(
    modelClass: CardLayoutModelConstructorType,
    recordLayout: RecordLayout
  ): boolean {
    if (!recordLayout.cardLayout?.epicsEnabled) return false;

    return super.availableForModel(modelClass, recordLayout);
  }

  static subqueriesForModel() {
    return { epic: ['name'] };
  }

  get title() {
    return `${terminology('Epic')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('epic')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.epic?.name };
  }
}
